import React from "react";
import { Button } from "react-bootstrap";
import ListPage from "../Common/ListPage";
import { Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlusCircle,
  faCog,
  faUsers,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import Item from "../Common/Item";
import moment from "moment";
import dataService from "../Common/dataService";
import * as Yup from "yup";

interface RouterProps {
  id: string;
}

interface Props extends RouteComponentProps<RouterProps> {
  action: "list" | "add" | "edit";
}

interface State {}

class Groups extends React.Component<Props, State> {
  public state: State = {};

  public render() {
    let endpoint = "/api/groups/";

    let formFields = [
      {
        name: "name",
        type: "text",
        label: "Nom",
        validation: Yup.string().required(
          "Vous devez renseigner le nom du groupe"
        ),
      },
      {
        name: "is_active",
        type: "radio",
        label: "Etat",
        options: {
          values: [
            { value: true, name: "Actif" },
            { value: false, name: "Inactif" },
          ],
        },
        defaultValue: true,
        permissions: ["IS_ACTIVE"],
      },
      {
        name: "sections",
        type: "select-multiple",
        label: "Sections",
        options: {
          values: dataService.getData("sections", { is_active: true }),
        },

        validation: Yup.array().required(
          "Vous devez choisir au moins une section"
        ),
      },
      {
        name: "updated_at",
        type: "readonly",
        label: "Dernière modification",
        transform: (value: any) => {
          let date =
            value && moment.unix(value).format("DD/MM/YYYY à HH:mm:ss");
          return date || "";
        },
      },
    ];
    let listFields = [
      { name: "name", label: "Name", orderable: true },
      {
        name: "is_active",
        label: "Actif",
        className: "text-center",
        options: { width: "100px" },
        orderable: true,
      },
      {
        name: "users_list",
        label: "Liste des utilisateurs",
        className: "text-center",
        transform: (value: any, item: any) => {
          return (
            <Link to={"/admin/users/?groups=" + item.id}>
              <FontAwesomeIcon icon={faUsers} />
            </Link>
          );
        },
        options: { width: "170px" },
      },
      {
        name: "sections_list",
        label: "Liste des sections",
        className: "text-center",
        transform: (value: any, item: any) => {
          return (
            <Link to={"/admin/sections/?group=" + item.id}>
              <FontAwesomeIcon icon={faCog} />
            </Link>
          );
        },
        options: { width: "150px" },
      },
      {
        name: "updated_at",
        label: "Date de modification",
        options: { width: "215px" },
        orderable: true,
        transform: (value: any) => {
          return (
            (value && moment.unix(value).format("DD/MM/YYYY à HH:mm:ss")) || ""
          );
        },
      },
    ];
    let actions = [
      {
        name: "edit",
        label: "Modifier le groupe",
        icon: <FontAwesomeIcon icon={faEdit} />,
        url: "/admin/groups/edit/:id",
      },
      {
        name: "delete",
        label: "Supprimer le groupe",
        icon: <FontAwesomeIcon icon={faTrash} />,
        deleteMessage: {
          confirm: {
            title: "Supprimer le groupe",
            message: "Êtes-vous sûr de vouloir supprimer ce groupe?",
          },
          notificationMessage: "Le groupe a été supprimé avec succès",
          endpoint: endpoint,
        },
      },
    ];

    let searchFields = [
      {
        name: "name",
        label: "Nom groupe",
        options: {
          identifier: "name",
          source: "/api/groups/",
          label: "name",
          searchIsMutli: false,
        },
      },
    ];

    return (
      <div className="block">
        {this.props.action === "list" && (
          <span>
            <div className="button-add-user">
              <Link to="/admin/groups/add">
                <Button>
                  <FontAwesomeIcon icon={faPlusCircle} /> Ajouter un groupe
                </Button>
              </Link>
            </div>
            <h2>
              <Trans>Liste des groupes</Trans>
            </h2>

            <ListPage
              endpoint={endpoint}
              fields={listFields}
              actions={actions}
              searchFields={searchFields}
            />
          </span>
        )}
        {this.props.action === "add" && (
          <Item
            action="add"
            endpoint={endpoint}
            fields={formFields}
            name="Ajouter un groupe"
          />
        )}
        {this.props.action === "edit" && (
          <Item
            action="edit"
            endpoint={endpoint}
            fields={formFields}
            name="Modifier le groupe"
          />
        )}
      </div>
    );
  }
}

export default withRouter(Groups);
